import { Link } from 'react-router-dom';
import { useState } from 'react';
import StartYourFreeTrial from '../../components/StartYourFreeTrial';
import { LuClock3 } from 'react-icons/lu';
import { Helmet } from 'react-helmet-async';

const blogData = [
  {
    id: 1,
    img: '../images/creating-church-directory.png',
    //img src: https://unsplash.com/photos/woman-reading-book-dGxOgeXAXm8
    category: 'Create Your Directory',
    link: '/blog/effortlessly-create-and-maintain-church-directory',
    title: 'Effortlessly Create and Maintain Your Church Directory',
    description: 'Managing a church directory can be a daunting task, but it does not have to be. My Church Directory offers the advantages of a professional church photo directory without the accompanying hassle.',
    publishDate: '19/07/2024',
  },
  {
    id: 2,
    img: '../images/church-community.png',
    //img src: https://unsplash.com/photos/a-church-with-a-chandelier-hanging-from-the-ceiling-Bcvt3N8lnkM
    category: 'Church Community',
    link: '/blog/top-benifits-of-my-church-directory',
    title: 'Top Benefits of Using My Church Directory for Your Church Community',
    description: 'Maintaining an up-to-date church directory is crucial for fostering community and ensuring smooth communication within your congregation. My Church Directory offers a comprehensive solution that provides numerous benefits for your church community.',
    publishDate: '19/07/2024',
  },
  {
    id: 3,
    img: '../images/church-administration.png',
    //img src: Canva
    category: 'Church Directory Administration',
    link: '/blog/simplify-church-administration',
    title: 'Simplify Church Administration with My Church Directory',
    description: 'Managing a church involves numerous administrative tasks that can be time-consuming and complex. From keeping member records updated to communicating effectively with the congregation, church administration requires a streamlined approach to ensure everything runs smoothly.',
    publishDate: '20/07/2024',
  },
];

const Blog = () => {
  const cardsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(blogData.length / cardsPerPage);
  const startIndex = (currentPage - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const currentBlogData = blogData.slice(startIndex, endIndex);

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <Helmet>
        <title>My Church Directory Blogs | Online Church Directory Software</title>

        <meta
          name="description"
          content="Explore powerful church directory features including member management, mobile apps, email and text messaging, printable directories, and secure online access. Manage your church directory with ease."
        />
      </Helmet>

      <section className="bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex rounded-full bg-sky-100 text-secondary px-4 py-1 text-sm font-medium">
              Blog
            </span>

            <h1 className="different_heading mt-5 text-4xl lg:text-5xl font-bold text-slate-900">
              Church Management Tips & Resources
            </h1>

            <p className="mt-6 text-lg text-slate-600 leading-8">
              Explore articles, guides, and best practices to help your church improve
              communication, member engagement, leadership, and ministry management.
            </p>
          </div>

          <div>
            <img
              src="./images/blog-hero-photo.jpg"
              alt="Church Management Blog"
              className="rounded-3xl shadow-xl w-full"
            />
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-14">
            <h2 className="different_heading text-3xl font-bold">
              Latest Articles
            </h2>

            <p className="mt-3 text-slate-600">
              Helpful resources for pastors, administrators, and church leaders.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">

            {currentBlogData.map((item) => (
              <article
                key={item.id}
                className="bg-white rounded-2xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-lg transition duration-300"
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-56 object-cover"
                />

                <div className="p-6">

                  <span className="inline-flex rounded-full bg-sky-100 text-secondary px-3 py-1 text-xs font-medium">
                    {item.category}
                  </span>

                  <Link to={item.link}>
                    <h2 className="mt-4 text-xl font-bold text-slate-900 hover:text-secondary transition">
                      {item.title}
                    </h2>
                  </Link>

                  <p className="mt-3 text-slate-600 line-clamp-3">
                    {item.description}
                  </p>

                  <div className="mt-6 flex items-center justify-between">

                    <div className="flex items-center gap-2 text-sm text-slate-500">
                      <LuClock3 />
                      {item.publishDate}
                    </div>

                    <Link
                      to={item.link}
                      className="text-sky-600 font-semibold hover:text-sky-700"
                    >
                      Read More →
                    </Link>

                  </div>

                </div>
              </article>
            ))}

          </div>

        </div>
      </section>

      <section className="py-10">
        <div className="max-w-7xl mx-auto px-6">

          <div className="flex justify-center gap-4">

            <button
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
              className="rounded-xl border border-slate-300 px-6 py-3 font-medium hover:bg-slate-100 disabled:opacity-50"
            >
              ← Previous
            </button>

            <div className="flex items-center text-slate-600 font-medium">
              Page {currentPage} of {totalPages}
            </div>

            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
              className="rounded-xl bg-secondary text-white px-6 py-3 font-medium hover:bg-sky-700 disabled:opacity-50"
            >
              Next →
            </button>

          </div>

        </div>
      </section>

      <StartYourFreeTrial />
    </>
  )
}

export default Blog;